// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"885a0449","411":"0e9218ba","453":"f674ffec","950":"5fa2c583"}[chunkId] + ".chunk.js";
};